import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { Route, Switch } from 'react-router';
import { ModalContextProvider } from 'utils/contexts/modal';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { RoleDetailsPage } from './components/details';
import { RolesPage } from './components/index';
import { TABLE_COLUMNS } from './constants';
import {
  MembersContextProvider,
  PermissionsContextProvider,
  RolesContextProvider,
  UsersQueryContextProvider,
} from './contexts';

export const Roles = () => {
  return (
    <UsersQueryContextProvider>
      <MembersContextProvider>
        <PermissionsContextProvider>
          <SortingContextProvider
            defaultSortDirection={SORT_DIRECTIONS.ASCENDING}
            defaultSortField={TABLE_COLUMNS[0].id}
          >
            <PaginationContextProvider>
              <RolesContextProvider>
                <ModalContextProvider>
                  <Switch>
                    <Route exact path="/roles">
                      <RolesPage />
                    </Route>
                    <Route exact path="/roles/:roleId">
                      <RoleDetailsPage />
                    </Route>
                  </Switch>
                </ModalContextProvider>
              </RolesContextProvider>
            </PaginationContextProvider>
          </SortingContextProvider>
        </PermissionsContextProvider>
      </MembersContextProvider>
    </UsersQueryContextProvider>
  );
};
